import { FlexContainer } from "../../Container/FlexContainer";
import { IListItem } from "../../Container/List/IListItem";
import { TextItemEntry } from "./TextItemEntry";
import { Tag } from "../../Tag";
import { Div } from "../../Div";
import { toMap } from "../../../../../HA";

export class SelectEntry extends FlexContainer implements IListItem {

    public getValue(): any {
        const item = this.get("item");
        let itemValue = null;

        if (item instanceof TextItemEntry) {
            itemValue = item.getValue();
        }

        return this.has("v") ? this.get("v") : (itemValue) ? itemValue : this.get("item");
    }

    public equals(value: any) {
        const current = this.getValue();
        if (current instanceof Tag) {
            return current.equals(value);
        }
        return this.getValue() === value;
    }

    protected initialize(data: any) {
        if (typeof data === "string") {
            data = toMap({v: data});
        }
        if (data instanceof Tag) {
            data = toMap({item: data, tag: data});
        }

        super.initialize(data);
    }

    protected createSelf() {
        const item = new FlexContainer();
        const v = this.get("v");
        if (v) {
            item.appendChild(new Div(v));
            item.setAttribute("v", v);
        } else if (this.has("item")) {
            item.appendChild(this.get("item"));
        }

        item.addClass("sitem");
        this.setElement(item.getElement());
    }
}
